import React from 'react';
import KnowledgeBasePanel from './knowledge/KnowledgeBasePanel.js';

const KnowledgeBasePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <KnowledgeBasePanel 
        isOpen={true} 
        onClose={() => window.history.back()} 
      />
    </div>
  );
};

export default KnowledgeBasePage;
